import { createServiceFunction } from "../http/http.service"; // app doesn't run with import pointing to "../http"... no clue as to why...
import { staticSettings } from "@montana/helpers/static-settings.helper";
import { deleteTokens, getRefreshToken, setToken } from "@montana/helpers/auth-token.helper";
import { ILoginResponse } from "@montana/containers/authentication/authentication.sagas";

export const fetchLogin = createServiceFunction((username?: string, password?: string) => {
    const apiUrl = staticSettings.apiUrl;
    const url = `${apiUrl}/token`;

    return f => f(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `grant_type=password&username=${username}&password=${password}`
    });
});

export const fetchUser = createServiceFunction(() => {
    const apiUrl = staticSettings.apiUrl;
    const url = `${apiUrl}/api/contact/data`;

    return f => f(url);
});

function handleNotOk(): void {
    deleteTokens();
}

/*eslint-disable */
function handleOk(response: Response): void {
    response.json()
        .then((loginResponse: ILoginResponse) => {
            if (!loginResponse.access_token || !loginResponse.refresh_token || !loginResponse.expires_in) {
                throw new Error();
            }

            setToken(loginResponse);
        }).catch(handleNotOk);
}
/*eslint-enable */

export function refreshSecurityToken(token?: string): Promise<Response> {
    const apiUrl = staticSettings.apiUrl;
    const url = `${apiUrl}/token`;

    const refreshToken = token || getRefreshToken();

    return fetch(`${url}`,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: `grant_type=refresh_token&client_id=${'admin'}&refresh_token=${refreshToken}`,
            method: "POST",
        })
        .then((res) => {
            if (!res.ok) {
                handleNotOk();
            } else {
                handleOk(res);
            }

            return res;
        });
}
